<template>
  <div class="-mx-[1.5rem] mt-[16px]">
    <b-table
      :items="dataFetcher.data"
      :fields="CAMPAIGN_LIST_TABLE_FIELDS"
      :empty-text="emptyTextLabel"
      responsive
      show-empty
      small
      sticky-header
      class="!max-h-[calc(100vh-330px)] !mb-0"
      :tbody-tr-class="{'hover:bg-slate-100 transition-colors duration-300 cursor-pointer': dataFetcher.data.length}"
      @row-clicked="handleRowClicked"
    >
      <template #cell(no)="{ index }">
        {{ index + 1 }}
      </template>
      <template #cell(status)="{ value }">
        <status-pill :status="tempMappedStatus(value)" />
      </template>
      <template #cell(product_category)="{ value }">
        <category-pill
          :category="value"
          :max-displayed-item="2"
        />
      </template>
      <template #custom-foot>
        <td colspan="100%">
          <load-more-data
            v-if="dataFetcher"
            :fetcher="dataFetcher"
          />
        </td>
      </template>
      <template #empty="{emptyText}">
        <empty-table-card
          :fetcher="dataFetcher"
          :label="emptyText"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { CAMPAIGN_LIST_TABLE_FIELDS } from '../config'
import LoadMoreData from '../../creator-management/LoadMoreData.vue'
import EmptyTableCard from '../../creator-management/EmptyTableCard.vue'
import StatusPill from './StatusPill.vue'
import CategoryPill from '../../creator-management/CategoryPill.vue'

export default {
  name: 'TableComponent',
  components: {
    LoadMoreData,
    EmptyTableCard,
    StatusPill,
    CategoryPill,
  },
  data() {
    return {
      dataFetcher: null,
      CAMPAIGN_LIST_TABLE_FIELDS,
      drawerData: null,
    }
  },
  computed: {
    emptyTextLabel() {
      if (this.dataFetcher.isLoading) return 'Memuat data...'
      if (this.dataFetcher.error) return 'Terdapat kesalahan saat memuat data'
      return 'Tidak ada data yang ditampilkan.'
    },
  },
  created() {
    this.initializeFetcher()
  },
  methods: {
    /**
     * Inisialisasi paginated fetcher untuk daftar kreator
     */
    initializeFetcher() {
      const fnFetch = ({
        offset, limit, search, sort_by, sort_type, status,
      }) => this.$http_new.get('/komclass/api/v1/komlabs/campaigns/list', {
        params: {
          offset,
          limit,
          search,
          sort_by,
          sort_dir: sort_type,
          status,
        },
      }).then(res => {
        const { items, counts } = res.data.data
        this.$emit('data-count', { ...counts, 'pre campaign': counts.pre_campaign, semua: counts.all })
        return {
          data: items,
        }
      }).catch(() => {
        if (this.dataFetcher.offset === 0) {
          throw new Error('Gagal memuat data')
        }
        return {
          data: [],
        }
      })

      this.dataFetcher = createPaginatedFetcher(fnFetch, 0, 20)
    },
    /**
     * Reset dan muat ulang data tabel dengan filter baru
     * @param {Object} params
     */
    refreshData({
      search, sort_by, sort_type, status,
    }) {
      this.dataFetcher.fetchData({
        reset: true,
        options: {
          search,
          sort_by,
          sort_type,
          status,
        },
      })
    },
    /**
     * Handles row click event to navigate to the campaign detail page.
     * Automatically sets the 'tab' query parameter based on the campaign's status
     * (skips setting it for 'pre_campaign' as it's the default).
     *
     * @param {Object} rowData - The data of the clicked row
     * @param {number|string} rowData.id - Campaign ID
     * @param {string} rowData.status - Campaign status
     */
    handleRowClicked({ id, status }) {
      if (!id) {
        this.$toast_error({ message: 'Tidak dapat menampilkan detail Campaign karena data tidak valid' })
        return
      }
      this.$router.push({
        name: 'campaign-detail-komlabs',
        params: {
          id,
        },
        query: {
          tab: status === 'pre_campaign' ? undefined : status,
        },
      })
    },
    tempMappedStatus(status) {
      const data = {
        registered: 'pre_campaign', tap: 'ongoing', mcn: 'draft', blacklisted: 'ended',
      }
      return data[status.toLowerCase()] || status
    },
  },
}
</script>
